// Onboarding questions configuration

export type QuestionOption = {
  value: string;
  label: string;
  icon?: string;
};

export type Question = {
  id: string;
  title: string;
  subtitle?: string;
  type: 'choice' | 'number';
  options?: QuestionOption[];
  presets?: number[];
  min?: number;
  max?: number;
  multiSelect?: boolean;
};

export const onboardingQuestions: Question[] = [
  {
    id: 'mood',
    title: 'When you pick up a book, what are you hoping for?',
    subtitle: 'Tell us what draws you to reading',
    type: 'choice',
    options: [
      { value: 'Escape into another world', label: 'Escape into another world', icon: '🌍' },
      { value: 'Sharpen my mind', label: 'Sharpen my mind', icon: '🧠' },
      { value: 'Feel all the feels', label: 'Feel all the feels', icon: '💕' },
      { value: 'Laugh or be entertained', label: 'Laugh or be entertained', icon: '😄' },
      { value: 'Surprise me', label: 'Surprise me', icon: '✨' }
    ]
  },
  {
    id: 'growth',
    title: 'What would you like to grow in your reading life?',
    subtitle: 'Your reading goals matter to us',
    type: 'choice',
    multiSelect: true,
    options: [
      { value: 'Read more books overall', label: 'Read more books overall', icon: '📖' },
      { value: 'Explore new genres', label: 'Explore new genres', icon: '🗺️' },
      { value: 'Spend more time daily', label: 'Spend more time daily', icon: '⏱️' },
      { value: 'Get back into the habit', label: 'Get back into the habit', icon: '🔄' },
      { value: 'Connect with friends through books', label: 'Connect with friends through books', icon: '🤝' }
    ]
  },
  {
    id: 'goal',
    title: 'How many books would you like to read this year?',
    subtitle: 'Pick a preset or set your own goal',
    type: 'number',
    presets: [8, 12, 24, 36, 52],
    min: 0,
    max: 200
  },
  {
    id: 'weeklyGoal',
    title: 'How many days per week do you want to read?',
    subtitle: 'Build a reading streak by logging progress or doing focus sessions',
    type: 'choice',
    options: [
      { value: '3', label: '3 days - Light & flexible', icon: '🌱' },
      { value: '4', label: '4 days - Steady habit', icon: '🌿' },
      { value: '5', label: '5 days - Strong routine', icon: '🌳' },
      { value: '6', label: '6 days - Almost daily', icon: '🔥' },
      { value: '7', label: '7 days - Every day', icon: '⚡' }
    ]
  }
];
